import { isZyapp, isWeiXin, commandHandler } from './modulesForApp';
import axios from 'axios';
const wx = require('weixin-js-sdk');
const env = process.env.CURRENT_MODE;
const link = (curUrl) => {
    var reUrl = window.location.origin;
    switch(env) {
        case 'pre':
        case 'prod':
            curUrl = curUrl.replace(reUrl, 'https://app.cmbi.info');
            break;
        // case 'uat':
        //     curUrl = curUrl.replace(reUrl, 'http://uat-op.cmbi.info');
        //     break;
        // case 'test':
        // case 'dev':
        //     curUrl = curUrl.replace(reUrl, 'http://test-op.cmbi.info');
        //     break;
    }
    console.info('返回值curUrl', curUrl);
    return curUrl;
};
const initShare = async (type = 'views', data = {}) => {
    if (isWeiXin()) {
        initWechatShare();
    } else if (isZyapp()) {
        const notifyObj = {
            type,
            params: data
        };
        console.log('notifyObj数据', notifyObj);
        commandHandler(notifyObj);
        return this;
    }
};
const transformOfflineUrl = (pageUrl) => {
    // file:///data/user/0/com.cmbi.zytx/cache/h5package/app.cmbi.info/appweb/knowledge/index.html?source=app&fromPage=我的#/
    // file:///data/user/0/com.cmbi.zytx/cache/h5package/app.cmbi.info/appweb/knowledge/index.html?source=app&fromPage=我的#/detail?id=392
    const env = process.env.CURRENT_MODE;
    const paramsArr = pageUrl.split('h5package/');
    const pathName = paramsArr[1].split('index.html');
    const protocol =  (env == 'prod' || env == 'pre') ? 'https://' : 'http://';
    let transformUrl;
    if (paramsArr[1].endsWith('#/')) {
        transformUrl = protocol + pathName[0];
    } else {
        const originUrl = pathName[1].split('#/');
        transformUrl = protocol + pathName[0] + originUrl[1];
    }
    // if (paramsArr[1].includes('?source=app#/')) {
    //     transformUrl = protocol + paramsArr[1].replace('index.html?source=app#/', '');
    // } else if (paramsArr[1].includes('index.html#/')) { 
    //     transformUrl = protocol + paramsArr[1].replace('index.html#/', '');
    // } else {
    //     transformUrl = protocol + paramsArr[1].replace('index.html/', '');
    // }
    return transformUrl;
};
// 微信二次分享
export const initWechatShare = async (data) => {
    if (data && data.url) {
        data.url = link(data.url);
    }
    if (isWeiXin()) {
        // 显示“点击右上角，在菜单中选择发送给好友或者分享到朋友圈
        // if (!document.getElementById('wx-share')) {
        //     const popShare = document.createElement('div');
        //     const img = document.createElement('img');
        //     img.setAttribute('src', 'https://lib.cmbi.info/weixin_share_cover.png');
        //     img.setAttribute('style', 'display:block;position:absolute;top:15px;right:15px;width:179px;height:148px;');
        //     popShare.setAttribute('id', 'wx-share');
        //     popShare.setAttribute('style', 'position: fixed;width: 100%;height: 100%;top: 0;left: 0;z-index: 99;background-color: rgba(0,0,0,.75);');
        //     document
        //         .getElementsByTagName('body')
        //         .item(0)
        //         .appendChild(popShare);
        //     document.getElementById('wx-share').appendChild(img);
        //     document.querySelector('#wx-share').addEventListener('touchend', function(e) {
        //         e.stopPropagation();
        //         this.parentNode.removeChild(this);
        //     });
        // }
        let url  = data.url.split('#')[0];
        console.log(window.location.href);
        const res = await axios({
            url: '/share',
            method: 'get',
            params: {
                url: decodeURIComponent(url)
            }
        });
        wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.data.appId, // 必填，公众号的唯一标识
            timestamp: res.data.timeStamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.signature, // 必填，签名
            jsApiList: [
                'onMenuShareAppMessage', // 分享给好友
                'onMenuShareTimeline' // 分享给朋友圈] // 必填，需要使用的JS接口列表
            ]
        });
        const config = {
            title: data.title,
            desc: data.summary,
            link: data.url,
            imgUrl: data.img,
            success() {
                console.log('已分享');
            },
            cancel() {
                console.log('已取消');
            }
        };
        wx.ready(function() {
            console.info('readly');
            wx.onMenuShareAppMessage(config);
            wx.onMenuShareTimeline(config);
        });
    }
}

// app分享
export const appShare = data => {
    const isOffline = process.env.isOffline;
    if (data && data.url) {
        if (isOffline) {
            data.url = transformOfflineUrl(data.url);
        }
        // data.url = link(data.url);
    }
    const notifyObj = {
        type: 'share',
        params: data
    };
    console.log('notifyObj数据', notifyObj);
    commandHandler(notifyObj);
}

export const getShareInfo = data => initShare('views', data);

export const shareToFriend = data => initShare('weixinfriend', data);

export const shareToTimeLine = data => initShare('weixinmoments', data);

export const shareMore = data => initShare('share', data);
